import { SubjectData } from 'shell/models/person';
import { AccordionSubjectAttributes as SubjectAttributesVM } from 'shell/view-models/accordion-subject-attributes';

export const transformSubjectAttributes = (
  person: SubjectData
): SubjectAttributesVM | undefined => {
  const originReturnData: SubjectAttributesVM | undefined = person.attributiSoggetto
    ? {
        homeless: person.attributiSoggetto?.senzaFissaDimora === 'S' ? true : false,
        subject: person.attributiSoggetto?.soggettoCertificabile || '',
        subjectDescription: person.attributiSoggetto?.descrizioneSoggettoCertificabile || '',
      }
    : undefined;

  return originReturnData;
};
